import { h, Fragment } from "preact";
import { createPortal } from "preact/compat";
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import {gridSize, smallScreenThreshold} from "../style-variables";


const Blanket = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    background: #000;
    top: 0;
    left: 0;
    z-index: 9998;
    opacity: ${props => props.isOpen ? 0.5 : 0};
    visibility: ${props => props.isOpen ? "visible" : "hidden"};
    transition: opacity 0.3s, visibility 0.3s;
`
const ModalContainer = styled.div`
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    visibility: ${props => props.isOpen ? "visible" : "hidden"};
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: visibility 0.3s;
`
const Modal = styled.div`
    position: fixed;
    box-sizing: border-box;
    width: 800px;
    height: 80%;
    background: #fff;
    z-index: 9999;
    margin: auto;
    opacity: ${props => props.isOpen ? 1 : 0};
    transition: opacity 0.3s, transform 0.3s;
    transform: ${props => props.isOpen ? `translateY(0)`: `translateY(-${gridSize}px)`};
    border-radius: ${gridSize / 4}px;
    overflow: auto;
    
    @media screen and (max-width: ${smallScreenThreshold}) { 
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: 0;
    }
`

const CloseModalButton = styled.button`
    font-size: ${gridSize}px;
    padding: ${gridSize};
    border: none;
    background: none;
    cursor: pointer;
`

const ModalHeader = styled.header`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    padding-left: ${gridSize}px;
    width: 100%;
    top: 0;
    box-shadow: 12px 0 48px #fff;
    background: #fff;
`
const ModalContent = styled.div`
    margin: 0 ${gridSize}px;
`
export const ModalDialog = ({ children, isOpen, onBlanketClick, onCloseClick, header }) => {
    return createPortal(
        <>
            <ModalContainer isOpen={isOpen}>
                <Modal isOpen={isOpen}>
                    <ModalHeader> {header} <CloseModalButton onClick={onCloseClick}><FontAwesomeIcon icon={faTimes}/></CloseModalButton></ModalHeader>
                    <ModalContent>
                        {children}
                    </ModalContent>
                </Modal>
            </ModalContainer>
            <Blanket isOpen={isOpen} onClick={onBlanketClick} />
        </>,
        document.body
    )

}